import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

/**
 * A custom element that displays model details (height, worn size) for the
 * currently selected variant. It listens for variant update events and
 * replaces its inner content with the server-rendered version from the
 * fetched section HTML.
 */
class ProductModelDetails extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateModelDetails);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateModelDetails);
  }

  /**
   * Updates the model details based on the selected variant.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateModelDetails = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newElement = event.detail.data.html.querySelector('product-model-details');

    if (!newElement) return;

    morph(this, newElement, { childrenOnly: true });
  };
}

if (!customElements.get('product-model-details')) {
  customElements.define('product-model-details', ProductModelDetails);
}
